import { IDailyRentOfferForMobileSite } from '../../../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';

export function getFeaturesList(features: IDailyRentOfferForMobileSite['features']): string[] {
  const candidates = [features.objectType, features.totalArea, features.floorInfo];

  return candidates.filter((feature): feature is string => Boolean(feature));
}
